import { render, staticRenderFns } from "./two_factor_form.vue?vue&type=template&id=3bbb971b&scoped=true"
import script from "./two_factor_form.vue?vue&type=script&lang=ts"
export * from "./two_factor_form.vue?vue&type=script&lang=ts"
import style0 from "./two_factor_form.vue?vue&type=style&index=0&id=3bbb971b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbb971b",
  null
  
)

export default component.exports